import { callEndpoint } from '../backend';
import { ensureMemberSettings } from './ensureMemberSettings';

export const requestValidationOfClientTokenViaEmailToken = (email) =>
  callEndpoint(
    callEndpoint.endpoints.requestValidationOfClientTokenViaEmailToken,
    { email },
  );

export const validateClientTokenViaEmailToken = (emailToken) => {
  callEndpoint(callEndpoint.endpoints.validateClientTokenViaEmailToken, {
    emailToken,
  });
};

export const initialize = async () => {
  await ensureMemberSettings();
};

export { ensureMemberSettings } from './ensureMemberSettings';
